import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, functions } from "../firebase-config";
import { httpsCallable } from "firebase/functions";

export default function LoginPage() {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");
  const [userPass, setUserPass] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleLogin = async () => {
    if (!userEmail || !userPass) {
      setAlertMessage("Please enter both email and password.");
      return;
    }

    setIsLoading(true);
    setAlertMessage("");

    try {
      // 1️⃣ SIGN IN (unchanged)
      await signInWithEmailAndPassword(
        auth,
        userEmail.trim(),
        userPass
      );

      // 2️⃣ UPDATE LAST LOGIN (NON-BLOCKING)
try {
  const updateLastLogin = httpsCallable(functions, "updateLastLogin");
  await updateLastLogin();
} catch (err) {
  // 🔒 Do NOT block login if Cloud Function fails
  console.warn("Last login update failed:", err);
}

      // ❗ DO NOT NAVIGATE HERE
      // App.js handles redirect via onAuthStateChanged

    } catch (error) {
      console.error("Login failed:", error);
      setAlertMessage("Login failed. Check email and password.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1A1D24] p-6">
      <div className="bg-[#252831] shadow-2xl p-8 rounded-xl w-full max-w-sm text-white border border-gray-700">
        <h2 className="text-3xl font-bold text-center mb-6 text-orange-400">
          Welcome Back
        </h2>

        {alertMessage && (
          <div className="bg-red-500/20 text-red-400 p-3 rounded-lg mb-4 text-sm text-center">
            {alertMessage}
          </div>
        )}

        <input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          className="border border-gray-600 bg-gray-800 text-white p-3 w-full mb-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
          placeholder="Email"
          value={userEmail}
          onChange={(e) => setUserEmail(e.target.value)}
        />

        <input
          id="password"
          name="password"
          type="password"
          autoComplete="current-password"
          className="border border-gray-600 bg-gray-800 text-white p-3 w-full mb-6 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
          placeholder="Password"
          value={userPass}
          onChange={(e) => setUserPass(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleLogin()}
        />

        <button
          className="bg-orange-500 hover:bg-orange-600 text-white w-full py-3 rounded-lg font-semibold disabled:opacity-50 transition"
          onClick={handleLogin}
          disabled={isLoading}
        >
          {isLoading ? "Signing in..." : "Login"}
        </button>

        <button
          className="text-center text-sm text-gray-500 mt-4 w-full hover:text-white"
          onClick={() => navigate("/")}
        >
          ← Back to Landing Page
        </button>
      </div>
    </div>
  );
}
